import { CloseOutlined } from "@ant-design/icons";
import { Button, Flex, Space, Typography } from "antd";
import { ReactComponent as TickSquareLinear } from "Icons/vuesax/tick-square.svg";

export const Header = ({
  isEditing = false,
  header,
  editHeader,
  onSubmit,
  onClose
}: {
  isEditing?: boolean;
  header: string;
  editHeader?: string;
  onSubmit?: () => void;
  onClose: () => void;
}) => (
  <Flex wrap gap="middle" align="end" justify="space-between" style={{ marginBottom: "16px" }}>
    <Typography.Title level={4}>{isEditing ? editHeader : header}</Typography.Title>
    <Space size="small">
      {onSubmit && (
        <Button
          type="primary"
          htmlType="submit"
          className="default-button primary-btn"
          onClick={onSubmit}>
          <TickSquareLinear className="default-icon" />
          <span>Save</span>
        </Button>
      )}
      <Button
        style={{ border: "none" }}
        icon={<CloseOutlined style={{ fontSize: ".75rem" }} />}
        onClick={e => onClose()}></Button>
    </Space>
  </Flex>
);
